import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=154ba69a&scoped=true"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ImageBlock.vue?vue&type=style&index=0&id=154ba69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ba69a",
  null
  
)

export default component.exports